import React from "react";
import Link from "next/link";
const AreaQualifierClassList = ({
  classes
}) => {
  return <div role="table" className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 lg:rounded-2lg w-full border bg-white text-sm dark:text-white" data-sentry-component="AreaQualifierClassList" data-sentry-source-file="area-qualifier-class-list.jsx">
			<div className="dark:bg-jacarta-600 bg-jacarta-50 rounded-t-2lg flex" role="row">
				<div className="w-[28%] py-3 px-4" role="columnheader">
					<span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
						Class
					</span>
				</div>
			</div>
			{classes?.map(item => {
      return <Link href={`/loretta-lynn-tracker/area-qualifiers/class/${encodeURIComponent(item.name)}`} key={item.name} className="flex transition-shadow hover:shadow-lg" prefetch={false}>
						<div className="dark:border-jacarta-600 border-jacarta-100 flex w-[100%] items-center border-t py-4 px-4" role="cell">
							<span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
								{item.name}
							</span>
						</div>
					</Link>;
    })}
		</div>;
};
export default AreaQualifierClassList;